import { render, staticRenderFns } from "./bonus_coupon_list.vue?vue&type=template&id=56c8696f&scoped=true&"
import script from "./bonus_coupon_list.vue?vue&type=script&lang=js&"
export * from "./bonus_coupon_list.vue?vue&type=script&lang=js&"
import style0 from "./bonus_coupon_list.vue?vue&type=style&index=0&id=56c8696f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8696f",
  null
  
)

export default component.exports